<!-- Error Views -->
<app-module-error *ngIf="isNoMetric" [noMetric]="true"></app-module-error>
<app-module-error *ngIf="isDateRangeTooWideIntraday" [dateRangeTooWideIntraday]="true"></app-module-error>
<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<!-- Content -->
<div class="h-100 w-100 MetricBreakDownValue" *ngIf="dataLoadSuccess && highcharts && configHighChart && !noData || !isDateRangeTooWideIntraday || !isNoMetric">

    <!-- Single Views -->
    <div class="d-flex flex-column position-relative w-100 h-100 chartContainer" *ngIf="moduleState.view !== 'dual'">
        <highcharts-chart 
            *ngIf="moduleState.view === 'chart' && configHighChart"
            class="w-100 h-100"
            [Highcharts]="highcharts"
            [options]="configHighChart"
            (chartInstance)="setChartInstance($event)"
            >
        </highcharts-chart>
        
        <div class="performanceContent" *ngIf="moduleState.view === 'table'">
            <!-- Search -->
            <div *ngIf="!config.isCxOne" class="search-box live-search w-75 mx-auto my-2" [hidden]="!searchOpen">
                <input #searchBox type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue" [ngModelChangeDebounceTime]="400" (ngModelChangeDebounced)="applyFilter()"
                    placeholder="Search" cvLocalizedPlaceholder langSection="Common" langKey="Search" />
                <span class="clear-input" role="button" tabindex="0" [hidden]="!(filterValue.length > 0)" (click)="clearFilter()"></span>
            </div>
            
            <!-- Search cxone -->
            <div *ngIf="config.isCxOne" class="cxone-live-search ml-2 my-2" [hidden]="!searchOpen">
                <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
                (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="400">
                </cxone-text-input>
                <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                        <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                    </svg>
                </i>
                <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                        <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                    </svg>
                </i>
            </div>
                                
            <!-- Ag Grid table component -->
            <div class="flex-fill intervalGridContainer" style="overflow-y: auto;">
            <ag-grid-angular
                #metricsBreakdownWidgetGrid
                *ngIf="gridOptions != null"
                class="ag-theme-balham flex-fill"
                [gridOptions]="gridOptions"
                style="height:100%; width:100%;">
            </ag-grid-angular>
            </div>
        </div>

    </div>

    <!-- Combo View - Directives are repeated here but in visually-formatting divs. Using *ngIf, they won't render and won't affect performance. -->
    <div class="combinationView" *ngIf="moduleState.view === 'dual'" id="MetricBreakDownSearch">
        <!-- Ag Grid table component -->
        <div class="halfPanel d-flex flex-column position-relative table-grid">
            <!-- Search -->
            <div *ngIf="!config.isCxOne" class="search-box live-search w-75 mx-auto my-2" [hidden]="!searchOpen">
                <input #searchBox type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue" [ngModelChangeDebounceTime]="400" (ngModelChangeDebounced)="applyFilter()"
                       placeholder="Search" cvLocalizedPlaceholder langSection="Common" langKey="Search" />
                <span class="clear-input" role="button" tabindex="0" [hidden]="!(filterValue.length > 0)" (click)="clearFilter()"></span>
            </div>
            <!-- Search cxone -->
            <div *ngIf="config.isCxOne" class="cxone-live-search ml-2 my-2" [hidden]="!searchOpen">
                <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
                                  (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="400">
                </cxone-text-input>
                <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                        <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                    </svg>
                </i>
                <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                        <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                    </svg>
                </i>
            </div>

            <!-- Error Container -->
            <div class="flex-fill intervalGridContainer" style="overflow-y: auto;">
                <ag-grid-angular 
                    #metricsBreakdownWidgetGrid
                    *ngIf="gridOptions != null"
                    class="ag-theme-balham flex-fill"
                    [gridOptions]="gridOptions"
                    style="height:100%; width:100%;">
                </ag-grid-angular>
            </div>
        </div>

        <div class="panelDivider"></div>
          
        <!-- ChartJS -->
        <div class="halfPanel">
            <highcharts-chart *ngIf="configHighChart" (chartInstance)="setChartInstance($event)" [Highcharts]="highcharts"
                [options]="configHighChart" class="w-100 h-100"></highcharts-chart>
        </div>
    </div>

</div>
